/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Container, Stack, Typography, Grid, Button, TextField,
    MenuItem, Tooltip, IconButton, Modal
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import Card from '@material-ui/core/Card';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from '../../../Common/AlertDialog';
import ImageUploader from 'react-images-upload';
import CardMedia from '@material-ui/core/CardMedia';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import TokenDecoder from 'src/helpers/TokenDecoder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import RotateRightIcon from '@material-ui/icons/RotateRight';

export function Document({ setDocumentData, farmerId, setDocumentCount, factoryType, isEditType, nicEdit }) {
    const useStyles = makeStyles((theme) => ({
        root: {
            transform: 180
        }
    }));

    const classes = useStyles();
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [farmerDocumentType, setFarmerDocumentType] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [rotateImage, setRotateImage] = useState(0);
    const [ImageObject, setImageObject] = useState();
    const [ImageObject1, setImageObject1] = useState();
    const [open, setOpen] = useState(false);
    const [DeletePopUp, setDeletePopUp] = useState({
        index: 0,
        farmerDocumentID: 0
    });
    const [formData, setFormData] = useState({
        image: '',
        fileName: '',
        fileExtension: '',
        image: '',
        farmerDocumentTypeID: 0,
        documentExpiryDate: '' //new Date().toISOString().split('T')[0]
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        isEditType: 1,
        submitButtonName: "Add",
        pageheadername: "Save Supplier Document"
    });

    const BankSaveSchema = Yup.object().shape({
        image: Yup.number().required('Bank required'),
        farmerDocumentTypeID: Yup.number().min(1, 'Document Type is Required').required('Document Type is Required'),
        documentExpiryDate: Yup.string().nullable(true)
        //documentExpiryDate: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            image: formData.image,
            farmerDocumentTypeID: formData.farmerDocumentTypeID,
            documentExpiryDate: formData.documentExpiryDate
        },

        validationSchema: BankSaveSchema,
        onSubmit: () => {
            //addDoc(values)
        },
        enableReinitialize: true

    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        if (farmerId > 0) {
            trackPromise(getFarmerDocument(farmerId));
        }
        trackPromise(GetAllFarmerDocumentType())
    }, [farmerId]);

    async function GetAllFarmerDocumentType() {
        const res = await services.GetAllFarmerDocumentType()
        setFarmerDocumentType(res)
    }

    function onDrop(picture, imageUrl) {
        if (imageUrl.length == 0) {
            toast.error("Image not supported");
            return;
        }
        else {
            var convertedString = imageUrl[0];
            var fields = convertedString.split(",");
            var fields2 = fields[0].split(";");
            var fields3 = fields2[1].split("=");
            var fields4 = fields3[1].split(".");

            setImageObject(fields[1]);
            setFormData({
                ...formData,
                image: fields[1],
                fileName: fields3[1],
                fileExtension: fields4[1]
            });
        }
    }

    async function removeImage() {
        setImageObject(null);
    }

    function rotateDialog() {
        setRotateImage(rotateImage + 90)
    }

    async function addDoc(data) {
        if (values.farmerDocumentTypeID == 0) {
            toast.error("Document Type is Required");
            return;
        }
        if (values.farmerDocumentTypeID == 7 && values.documentExpiryDate == '') {
            toast.error("Expiry Date is Required");
            return;
        }
        else {
            if (farmerId > 0) {
                let model = {
                    farmerID: parseInt(farmerId),
                    image: formData.image,
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    fileName: formData.fileName,
                    documentTypeID: values.farmerDocumentTypeID,
                    documentExpiryDate: values.documentExpiryDate == "" ? null : values.documentExpiryDate
                };
                var resImage = await services.SaveFarmerDocumentInUpdate(model);
                if (resImage.statusCode === "Success") {
                    toast.success("Farmer Document Saved Succesfully");
                    getFarmerDocument(farmerId);
                    setImageObject(null);
                    setDocumentCount(tableData.length)
                } else {
                    toast.error('Error occured when document Save');
                }
            }
            else {
                const newArr = [...tableData];
                newArr[newArr.length] = {
                    ...newArr[newArr.length],
                    image: formData.image,
                    fileName: formData.fileName,
                    fileExtension: formData.fileExtension,
                    documentTypeID: parseInt(values.farmerDocumentTypeID),
                    farmerDocumentTypeName: farmerDocumentType.find(x => x.farmerDocumentTypeID == values.farmerDocumentTypeID).farmerDocumentTypeName,
                    documentExpiryDate: values.documentExpiryDate == "" ? null : values.documentExpiryDate
                };
                setTableData(newArr);
                setImageObject(null);
                setDocumentData(newArr);
                setDocumentCount(newArr.length)
            }
            formik.resetForm();
        }
    }

    async function getFarmerDocument(farmerId) {
        var imageData = await services.GetAllFarmerDocumentByFarmerID(farmerId);
        setTableData(imageData);
        setDocumentCount(imageData.length)
    }

    async function DeleteItemData() {
        if (farmerId > 0) {
            const imageData = await services.DeleteFarmerDocument(DeletePopUp.farmerDocumentID);
            if (imageData.statusCode === "Success") {
                toast.success("Farmer Document Removed Succesfully");
                getFarmerDocument(farmerId);
                setDocumentCount(tableData.length)
            } else {
                toast.error('Error occured when document deleted');
            }
        } else {
            var array = [...tableData];
            array.splice(DeletePopUp.index, 1);
            setTableData(array);
            setDocumentData(array);
            setDocumentCount(array.length)
            toast.success('Farmer document deleted successfully');
        }

    }

    // function settingPicture(data, type) {
    //     <CardMedia
    //         component="img"
    //         height="140"
    //         image={`data:image/jpeg;base64,${ImageObject1}`}
    //         {...getFieldProps('image')}
    //         error={Boolean(touched.image && errors.image)}
    //         helperText={touched.image && errors.image}
    //         onClick={handleImageClick(`data:image/jpeg;base64,${ImageObject1}`)}
    //     />
    //     if (data != null || data != undefined) {
    //         var fulldata =
    //             type == 'png'
    //                 ? `data:image/png;base64,${data}`
    //                 : `data:image/jpg;base64,${data}`;
    //         return <img src={fulldata} width="60" height="60" />;
    //     } else {
    //         return (
    //             <ImageSearchIcon
    //                 style={{
    //                     color: 'blue',
    //                     marginBottom: '-1rem',
    //                     marginTop: '0rem'
    //                 }}
    //                 size="small"
    //             />
    //         );
    //     }
    // }

    function settingPicture(data, type) {
        if (data != null || data != undefined) {
            var fulldata =
                type === 'png'
                    ? `data:image/png;base64,${data}`
                    : `data:image/jpg;base64,${data}`;
            return (
                <img
                    src={fulldata}
                    width="60"
                    height="60"
                    onClick={() => handleImageClick(fulldata)}
                    style={{ cursor: 'pointer' }}
                />
            );
        } else {
            return (
                <ImageSearchIcon
                    style={{
                        color: 'blue',
                        marginBottom: '-1rem',
                        marginTop: '0rem',
                        cursor: 'pointer'
                    }}
                    size="small"
                    onClick={() => handleImageClick('defaultImageURL')}
                />
            );
        }
    }

    function confirmData(y) {
        if (y) {
            DeleteItemData();
        }
    }

    async function confirmMessage(index, farmerDocumentID) {
        setEnableConfirmMessage(true);
        setDeletePopUp({
            ...DeletePopUp,
            index: index,
            farmerDocumentID: farmerDocumentID
        });
    }
    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.farmerDocumentTypeID} value={x.farmerDocumentTypeID}>{x.farmerDocumentTypeName}</MenuItem>)
            });
        }
        return items
    }

    const handleImageClick = (image) => {
        setSelectedImage(image);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <LoadingComponent />
            <Page title="Update Supplier |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form autoComplete="off"
                            noValidate onSubmit={handleSubmit}
                        >
                            <Typography variant="h6">
                                Proof of Identity *
                            </Typography>
                            {factoryType != 1 ?
                                <Stack spacing={2} margin={3}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Stack style={{ width: '250px' }}>
                                            {isEditType == 3 && nicEdit ? null : <ImageUploader
                                                //withIcon={false}
                                                singleImage={true}
                                                //withPreview={true}
                                                buttonText='Upload NIC or Driving License'
                                                onChange={onDrop}
                                                image={formik.values.image}
                                                imgExtension={['.jpg', '.png']}
                                                maxFileSize={5242880}
                                            />}
                                        </Stack>
                                        {ImageObject != null ?
                                            <Card>
                                                <CardMedia
                                                    component="img"
                                                    height="140"
                                                    image={`data:image/jpeg;base64,${ImageObject}`}
                                                    {...getFieldProps('image')}
                                                    error={Boolean(touched.image && errors.image)}
                                                    helperText={touched.image && errors.image}
                                                />
                                                <Button
                                                    fullWidth
                                                    color="secondary"
                                                    type="button"
                                                    variant="contained"
                                                    onClick={removeImage}
                                                >
                                                    Remove
                                                </Button>
                                            </Card> : null}
                                        {ImageObject != null ?
                                            <Grid item xs={4} sm={4} md={4}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    size="small"
                                                    label="Document Type *"
                                                    name="farmerDocumentTypeID"
                                                    value={formik.values.farmerDocumentTypeID}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('farmerDocumentTypeID')}
                                                    error={Boolean(touched.farmerDocumentTypeID && errors.farmerDocumentTypeID)}
                                                    helperText={touched.farmerDocumentTypeID && errors.farmerDocumentTypeID}
                                                >
                                                    <MenuItem key={0} value={0} > Select Document Type</MenuItem>
                                                    {generateDropDownMenu(farmerDocumentType)}

                                                </TextField>
                                            </Grid> : null}
                                        {ImageObject != null ?
                                            <Grid item xs={4} sm={4} md={4}>
                                                <TextField
                                                    fullWidth
                                                    id="outlined-name"
                                                    size="small"
                                                    type="date"
                                                    label="Document Expiry Date"
                                                    value={formik.values.documentExpiryDate}
                                                    inputProps={{
                                                        min: new Date().toISOString().split('T')[0],
                                                    }}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('documentExpiryDate')}
                                                    InputLabelProps={{ shrink: true }}
                                                    error={Boolean(touched.documentExpiryDate && errors.documentExpiryDate)}
                                                    helperText={touched.documentExpiryDate && errors.documentExpiryDate}
                                                // inputProps={{
                                                //     min: new Date().toISOString().split('T')[0],
                                                // }}
                                                />
                                            </Grid> : null}
                                    </Stack>
                                </Stack> : null}
                            {factoryType != 1 ?
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    {ImageObject != null ?
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="contained"
                                            color='secondary'
                                            onClick={addDoc}
                                        >
                                            Add
                                        </LoadingButton>
                                        : null}
                                </Stack> : null}
                            <Divider style={{ marginTop: '5px' }} variant="middle" />
                            {(tableData.length > 0) ?
                                <Stack style={{ marginTop: '5px' }} direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Card style={{ justifycontent: 'center', width: '65rem' }} >
                                        <TableContainer component={Paper} >
                                            <Table aria-label="caption table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">File Preview</TableCell>
                                                        <TableCell align="left">Document Type</TableCell>
                                                        <TableCell align="left">Document Expiry Date</TableCell>
                                                        <TableCell align="left">File Name</TableCell>
                                                        <TableCell align="left">File Extension</TableCell>
                                                        {factoryType != 1 ?
                                                            <TableCell align="center">Actions</TableCell> : null}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.map((rowData, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="left" component="th" scope="row" style={{ borderBottom: 'none' }}>
                                                                {settingPicture(rowData.image, rowData.fileExtension)}
                                                            </TableCell>
                                                            <Dialog open={open} onClose={handleClose} style={{ background: "transparent" }}
                                                                PaperProps={{
                                                                    style: {
                                                                        backgroundColor: 'transparent',
                                                                        boxShadow: 'none',
                                                                        overflowX: "hidden",
                                                                        overflowY: "hidden"
                                                                    },
                                                                }}>
                                                                <CardMedia style={{ transform: `rotate(${rotateImage}deg)` }} height="400" component="img" image={selectedImage} />
                                                                &nbsp;&nbsp;
                                                                <Tooltip title="Rotate" >
                                                                    <IconButton style={{ width: 40, background: "white" }} aria-label="delete"
                                                                        onClick={rotateDialog}
                                                                    >
                                                                        <RotateRightIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Dialog>
                                                            <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                {rowData.farmerDocumentTypeName}
                                                            </TableCell>
                                                            <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                {rowData.documentExpiryDate == null ? '-' : rowData.documentExpiryDate.split('T')[0]}
                                                            </TableCell>
                                                            <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                {rowData.fileName}
                                                            </TableCell>
                                                            <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                {rowData.fileExtension}
                                                            </TableCell>
                                                            {factoryType != 1 ?
                                                                <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                    <Tooltip title="Delete">
                                                                        <IconButton
                                                                            variant="outlined"
                                                                            color="error"
                                                                            onClick={() => confirmMessage(index, rowData.farmerDocumentID)}
                                                                            disabled={isEditType == 3 && nicEdit ? true : false}

                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell> : null}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Card>
                                </Stack> : null}
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want remove the document?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page>
        </>
    )
}